import { lazy } from "react";

const MainPage = lazy(() => import("./page"));

const routes = [
  {
    path: "/patient-management/appointment-rescheduling",
    component: MainPage,
    exact: false,
    name: "Citas Médicas - Reagendamiento"
  }
];

export default routes;
